import { IHistoryNiche, IHistoryFreeType, IHistoryUser } from "@/common/services/types";
import { SearchCard } from "../SearchCard";
import { SearchHistoryItem } from "../SearchHistoryItem";
import "./SearchHistoryResults.scss";

type TSearchHistoryResults = IHistoryNiche | IHistoryFreeType | IHistoryNiche | IHistoryUser;

interface ISearchHistoryResults {
  title: string;
  data: TSearchHistoryResults[];
  onClearAllHistory: () => void;
  onClearHistoryItem: (id: string) => void;
}

export const SearchHistoryResults = ({
  title,
  data,
  onClearAllHistory,
  onClearHistoryItem
}: ISearchHistoryResults) => {
  return (
    <div className="searchHistoryResults">
      <div className="searchHistoryResultsHeader">
        <h4 className="title">{title}</h4>
        <button className="clearAllBtn" onClick={onClearAllHistory}>Clear All</button>
      </div>
      <div className="searchHistoryResultsList">
        {data.map((item: TSearchHistoryResults, index: number) => (
          <SearchCard key={index} onClearHistoryItem={() => onClearHistoryItem(item.id)}>
            <SearchHistoryItem data={item} />
          </SearchCard>
        ))}
      </div>
    </div>
  );
};

